// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"f9c4766b","782":"b8d0d46d","898":"0023752e","939":"fcf88fb7"}[chunkId] + ".chunk.js";
};